module.exports = __webpack_public_path__ + "img/pika.4706d286.gif";